/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cardano API
 * RESTful API for Cardano
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetOpportunitiesParams,
  GetOpportunityStatsParams,
  NotificationState,
  OpportunityDetail,
  OpportunityPage,
  OpportunityStats,
  PruneRequest,
  PruneResponse,
  Thresholds,
  ThresholdsState
} from '../model';

import { arbBotFetcher } from '../../../lib/api/fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetOpportunitiesUrl = (params?: GetOpportunitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/opportunities?${stringifiedParams}` : `/api/opportunities`
}

export const getOpportunities = async (params?: GetOpportunitiesParams, options?: Parameters<typeof arbBotFetcher>[1]): Promise<OpportunityPage> => {

  return arbBotFetcher<OpportunityPage>(getGetOpportunitiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpportunitiesQueryKey = (params?: GetOpportunitiesParams,) => {
    return [
    `/api/opportunities`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOpportunitiesQueryOptions = <TData = Awaited<ReturnType<typeof getOpportunities>>, TError = void>(params?: GetOpportunitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunities>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpportunitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpportunities>>> = ({ signal }) => getOpportunities(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpportunities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOpportunitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getOpportunities>>>
export type GetOpportunitiesQueryError = void


export function useGetOpportunities<TData = Awaited<ReturnType<typeof getOpportunities>>, TError = void>(
 params: undefined |  GetOpportunitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpportunities>>,
          TError,
          Awaited<ReturnType<typeof getOpportunities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpportunities<TData = Awaited<ReturnType<typeof getOpportunities>>, TError = void>(
 params?: GetOpportunitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpportunities>>,
          TError,
          Awaited<ReturnType<typeof getOpportunities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpportunities<TData = Awaited<ReturnType<typeof getOpportunities>>, TError = void>(
 params?: GetOpportunitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunities>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOpportunities<TData = Awaited<ReturnType<typeof getOpportunities>>, TError = void>(
 params?: GetOpportunitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunities>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOpportunitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNotificationsUrl = () => {




  return `/api/opportunities/notifications`
}

export const getNotifications = async ( options?: Parameters<typeof arbBotFetcher>[1]): Promise<NotificationState> => {

  return arbBotFetcher<NotificationState>(getGetNotificationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNotificationsQueryKey = () => {
    return [
    `/api/opportunities/notifications`
    ] as const;
    }


export const getGetNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) => getNotifications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
export type GetNotificationsQueryError = unknown


export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetNotifyThresholdsUrl = () => {




  return `/api/opportunities/notifications/thresholds`
}

export const setNotifyThresholds = async (thresholds: Thresholds, options?: Parameters<typeof arbBotFetcher>[1]): Promise<NotificationState> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return arbBotFetcher<NotificationState>(getSetNotifyThresholdsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(thresholds)
  }
);}





export const getSetNotifyThresholdsMutationKey = () => ['setNotifyThresholds'] as const;

export const getSetNotifyThresholdsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setNotifyThresholds>>, TError,SetNotifyThresholdsMutationVariables, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof setNotifyThresholds>>, TError,SetNotifyThresholdsMutationVariables, TContext> => {

const mutationKey = getSetNotifyThresholdsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setNotifyThresholds>>, SetNotifyThresholdsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setNotifyThresholds(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetNotifyThresholdsMutationResult = NonNullable<Awaited<ReturnType<typeof setNotifyThresholds>>>
    export type SetNotifyThresholdsMutationBody = Thresholds
    export type SetNotifyThresholdsMutationError = unknown
    export type SetNotifyThresholdsMutationVariables = {data: Thresholds}

    export const useSetNotifyThresholds = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setNotifyThresholds>>, TError,SetNotifyThresholdsMutationVariables, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setNotifyThresholds>>,
        TError,
        SetNotifyThresholdsMutationVariables,
        TContext
      > => {
      return useMutation(getSetNotifyThresholdsMutationOptions(options), queryClient);
    }
    export const getResetNotifyThresholdsUrl = () => {




  return `/api/opportunities/notifications/thresholds`
}

export const resetNotifyThresholds = async ( options?: Parameters<typeof arbBotFetcher>[1]): Promise<NotificationState> => {

  return arbBotFetcher<NotificationState>(getResetNotifyThresholdsUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetNotifyThresholdsMutationKey = () => ['resetNotifyThresholds'] as const;

export const getResetNotifyThresholdsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetNotifyThresholds>>, TError,void, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof resetNotifyThresholds>>, TError,void, TContext> => {

const mutationKey = getResetNotifyThresholdsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetNotifyThresholds>>, void> = () => {


          return  resetNotifyThresholds(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetNotifyThresholdsMutationResult = NonNullable<Awaited<ReturnType<typeof resetNotifyThresholds>>>

    export type ResetNotifyThresholdsMutationError = unknown


    export const useResetNotifyThresholds = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetNotifyThresholds>>, TError,void, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetNotifyThresholds>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getResetNotifyThresholdsMutationOptions(options), queryClient);
    }
    export const getSendTestNotificationUrl = () => {




  return `/api/opportunities/notify-test`
}

export const sendTestNotification = async ( options?: Parameters<typeof arbBotFetcher>[1]): Promise<NotificationState> => {

  return arbBotFetcher<NotificationState>(getSendTestNotificationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSendTestNotificationMutationKey = () => ['sendTestNotification'] as const;

export const getSendTestNotificationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTestNotification>>, TError,void, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof sendTestNotification>>, TError,void, TContext> => {

const mutationKey = getSendTestNotificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTestNotification>>, void> = () => {


          return  sendTestNotification(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendTestNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof sendTestNotification>>>

    export type SendTestNotificationMutationError = void


    export const useSendTestNotification = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTestNotification>>, TError,void, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendTestNotification>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSendTestNotificationMutationOptions(options), queryClient);
    }
    export const getPruneOpportunitiesUrl = () => {




  return `/api/opportunities/prune`
}

export const pruneOpportunities = async (pruneRequest: PruneRequest, options?: Parameters<typeof arbBotFetcher>[1]): Promise<PruneResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return arbBotFetcher<PruneResponse>(getPruneOpportunitiesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pruneRequest)
  }
);}





export const getPruneOpportunitiesMutationKey = () => ['pruneOpportunities'] as const;

export const getPruneOpportunitiesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pruneOpportunities>>, TError,PruneOpportunitiesMutationVariables, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof pruneOpportunities>>, TError,PruneOpportunitiesMutationVariables, TContext> => {

const mutationKey = getPruneOpportunitiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pruneOpportunities>>, PruneOpportunitiesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pruneOpportunities(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PruneOpportunitiesMutationResult = NonNullable<Awaited<ReturnType<typeof pruneOpportunities>>>
    export type PruneOpportunitiesMutationBody = PruneRequest
    export type PruneOpportunitiesMutationError = unknown
    export type PruneOpportunitiesMutationVariables = {data: PruneRequest}

    export const usePruneOpportunities = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pruneOpportunities>>, TError,PruneOpportunitiesMutationVariables, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pruneOpportunities>>,
        TError,
        PruneOpportunitiesMutationVariables,
        TContext
      > => {
      return useMutation(getPruneOpportunitiesMutationOptions(options), queryClient);
    }
    export const getGetOpportunityStatsUrl = (params?: GetOpportunityStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/opportunities/stats?${stringifiedParams}` : `/api/opportunities/stats`
}

export const getOpportunityStats = async (params?: GetOpportunityStatsParams, options?: Parameters<typeof arbBotFetcher>[1]): Promise<OpportunityStats> => {

  return arbBotFetcher<OpportunityStats>(getGetOpportunityStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpportunityStatsQueryKey = (params?: GetOpportunityStatsParams,) => {
    return [
    `/api/opportunities/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOpportunityStatsQueryOptions = <TData = Awaited<ReturnType<typeof getOpportunityStats>>, TError = void>(params?: GetOpportunityStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityStats>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpportunityStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpportunityStats>>> = ({ signal }) => getOpportunityStats(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpportunityStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOpportunityStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getOpportunityStats>>>
export type GetOpportunityStatsQueryError = void


export function useGetOpportunityStats<TData = Awaited<ReturnType<typeof getOpportunityStats>>, TError = void>(
 params: undefined |  GetOpportunityStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpportunityStats>>,
          TError,
          Awaited<ReturnType<typeof getOpportunityStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpportunityStats<TData = Awaited<ReturnType<typeof getOpportunityStats>>, TError = void>(
 params?: GetOpportunityStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpportunityStats>>,
          TError,
          Awaited<ReturnType<typeof getOpportunityStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpportunityStats<TData = Awaited<ReturnType<typeof getOpportunityStats>>, TError = void>(
 params?: GetOpportunityStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityStats>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOpportunityStats<TData = Awaited<ReturnType<typeof getOpportunityStats>>, TError = void>(
 params?: GetOpportunityStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityStats>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOpportunityStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetOpportunityThresholdsUrl = () => {




  return `/api/opportunities/thresholds`
}

export const getOpportunityThresholds = async ( options?: Parameters<typeof arbBotFetcher>[1]): Promise<ThresholdsState> => {

  return arbBotFetcher<ThresholdsState>(getGetOpportunityThresholdsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpportunityThresholdsQueryKey = () => {
    return [
    `/api/opportunities/thresholds`
    ] as const;
    }


export const getGetOpportunityThresholdsQueryOptions = <TData = Awaited<ReturnType<typeof getOpportunityThresholds>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityThresholds>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpportunityThresholdsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpportunityThresholds>>> = ({ signal }) => getOpportunityThresholds({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpportunityThresholds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOpportunityThresholdsQueryResult = NonNullable<Awaited<ReturnType<typeof getOpportunityThresholds>>>
export type GetOpportunityThresholdsQueryError = unknown


export function useGetOpportunityThresholds<TData = Awaited<ReturnType<typeof getOpportunityThresholds>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityThresholds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpportunityThresholds>>,
          TError,
          Awaited<ReturnType<typeof getOpportunityThresholds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpportunityThresholds<TData = Awaited<ReturnType<typeof getOpportunityThresholds>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityThresholds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpportunityThresholds>>,
          TError,
          Awaited<ReturnType<typeof getOpportunityThresholds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpportunityThresholds<TData = Awaited<ReturnType<typeof getOpportunityThresholds>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityThresholds>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOpportunityThresholds<TData = Awaited<ReturnType<typeof getOpportunityThresholds>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityThresholds>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOpportunityThresholdsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetOpportunityThresholdsUrl = () => {




  return `/api/opportunities/thresholds`
}

export const setOpportunityThresholds = async (thresholds: Thresholds, options?: Parameters<typeof arbBotFetcher>[1]): Promise<ThresholdsState> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return arbBotFetcher<ThresholdsState>(getSetOpportunityThresholdsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(thresholds)
  }
);}





export const getSetOpportunityThresholdsMutationKey = () => ['setOpportunityThresholds'] as const;

export const getSetOpportunityThresholdsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOpportunityThresholds>>, TError,SetOpportunityThresholdsMutationVariables, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof setOpportunityThresholds>>, TError,SetOpportunityThresholdsMutationVariables, TContext> => {

const mutationKey = getSetOpportunityThresholdsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOpportunityThresholds>>, SetOpportunityThresholdsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setOpportunityThresholds(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOpportunityThresholdsMutationResult = NonNullable<Awaited<ReturnType<typeof setOpportunityThresholds>>>
    export type SetOpportunityThresholdsMutationBody = Thresholds
    export type SetOpportunityThresholdsMutationError = unknown
    export type SetOpportunityThresholdsMutationVariables = {data: Thresholds}

    export const useSetOpportunityThresholds = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOpportunityThresholds>>, TError,SetOpportunityThresholdsMutationVariables, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setOpportunityThresholds>>,
        TError,
        SetOpportunityThresholdsMutationVariables,
        TContext
      > => {
      return useMutation(getSetOpportunityThresholdsMutationOptions(options), queryClient);
    }
    export const getResetOpportunityThresholdsUrl = () => {




  return `/api/opportunities/thresholds`
}

export const resetOpportunityThresholds = async ( options?: Parameters<typeof arbBotFetcher>[1]): Promise<ThresholdsState> => {

  return arbBotFetcher<ThresholdsState>(getResetOpportunityThresholdsUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetOpportunityThresholdsMutationKey = () => ['resetOpportunityThresholds'] as const;

export const getResetOpportunityThresholdsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetOpportunityThresholds>>, TError,void, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof resetOpportunityThresholds>>, TError,void, TContext> => {

const mutationKey = getResetOpportunityThresholdsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetOpportunityThresholds>>, void> = () => {


          return  resetOpportunityThresholds(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetOpportunityThresholdsMutationResult = NonNullable<Awaited<ReturnType<typeof resetOpportunityThresholds>>>

    export type ResetOpportunityThresholdsMutationError = unknown


    export const useResetOpportunityThresholds = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetOpportunityThresholds>>, TError,void, TContext>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetOpportunityThresholds>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getResetOpportunityThresholdsMutationOptions(options), queryClient);
    }
    export const getGetOpportunityUrl = (id: number,) => {




  return `/api/opportunities/${id}`
}

export const getOpportunity = async (id: number, options?: Parameters<typeof arbBotFetcher>[1]): Promise<OpportunityDetail> => {

  return arbBotFetcher<OpportunityDetail>(getGetOpportunityUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpportunityQueryKey = (id: number,) => {
    return [
    `/api/opportunities/${id}`
    ] as const;
    }


export const getGetOpportunityQueryOptions = <TData = Awaited<ReturnType<typeof getOpportunity>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunity>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpportunityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpportunity>>> = ({ signal }) => getOpportunity(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpportunity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOpportunityQueryResult = NonNullable<Awaited<ReturnType<typeof getOpportunity>>>
export type GetOpportunityQueryError = void


export function useGetOpportunity<TData = Awaited<ReturnType<typeof getOpportunity>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpportunity>>,
          TError,
          Awaited<ReturnType<typeof getOpportunity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpportunity<TData = Awaited<ReturnType<typeof getOpportunity>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpportunity>>,
          TError,
          Awaited<ReturnType<typeof getOpportunity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpportunity<TData = Awaited<ReturnType<typeof getOpportunity>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunity>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOpportunity<TData = Awaited<ReturnType<typeof getOpportunity>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunity>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOpportunityQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






